var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,22.6L1.4,0L0,1.4l4.7,4.7c-2.7,2.3-4.2,5.2-4.4,5.4L0.1,12l0.2,0.4c0.2,0.3,4.3,8.4,11.7,8.4c2.2,0,4.1-0.7,5.7-1.7 l4.9,4.9L24,22.6z M10.1,11.5l2.3,2.3c-0.1,0-0.3,0.1-0.5,0.1c-1.1,0-1.9-0.9-1.9-1.9C10.1,11.8,10.1,11.7,10.1,11.5z M12,18.8 c-5.2,0-8.7-5.2-9.6-6.8c0.5-0.9,1.8-2.9,3.7-4.5L8.6,10c-0.3,0.6-0.5,1.3-0.5,2c0,2.2,1.8,3.9,3.9,3.9c0.7,0,1.4-0.2,2-0.5 l2.2,2.2C15,18.3,13.6,18.8,12,18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,5.2c5.2,0,8.7,5.2,9.6,6.8c-0.3,0.5-0.9,1.5-1.7,2.5l1.4,1.4c1.5-1.7,2.3-3.3,2.4-3.5l0.2-0.4l-0.2-0.4 c-0.2-0.3-4.3-8.4-11.7-8.4c-1.1,0-2,0.2-3,0.5l1.7,1.7C11.1,5.2,11.5,5.2,12,5.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 24,
    height: 24
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.34245241.svg";
export { ForwardRef as ReactComponent };